module.exports = __webpack_public_path__ + "img/fjgzzx.c0958f14.jpeg";